import React from "react";

import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import queryString from "query-string";
import Swal from "sweetalert2";

import ReactLoading from "react-loading";
import config from "../../config";

import { useNetworkState } from "react-use";
import Footer from "./Footer";
import Header from "./Header";
const Rate_card = () => {
  const [products, setProducts] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  React.useEffect(() => {
    // Fetch product pricing data
    const fetchPricingData = async () => {
      try {
        setLoading(true);
        const full_api = `${config.apiUrl}/shipment/getPricingData`;

        const response = await axios.post(
          full_api,
          {},
          { headers: config.headers }
        );

        if (response.data?.success && Array.isArray(response.data.products)) {
          setProducts(response.data.products);
        } else {
          console.warn("No products found in API response:", response.data);
          setProducts([]);
        }
      } catch (error) {
        console.error("Error fetching product pricing:", error);
        setProducts([]);
      } finally {
        setLoading(false);
      }
    };

    fetchPricingData();
  }, []);
  const getProductInitials = (name) => {
    if (!name) return "?";
    const words = name.trim().split(" ");
    if (words.length === 1) {
      return words[0].substring(0, 1).toUpperCase(); // "Bluedart" → "BL"
    }
    // For multiple words: "Bluedart Surface" → "BS"
    return words.map((word) => word.charAt(0).toUpperCase()).join("");
  };
  return (
    <div>
      <Header>
        <div className="content">
          {/* <!-- ═══════════ PAGE HEADER ═══════════ --> */}
          <div class="ol-header">
            <div class="ol-hd">
              <a
                href="javascript:history.back();"
                class="ol-back"
                title="Go back"
              >
                <i class="bi bi-arrow-left"></i>
              </a>
              <div>
                <div class="ol-title">Rate Card</div>
                <div class="ol-sub">
                  <span class="dot"></span> Pricing &amp; Charges{" "}
                  <span class="dot" style={{ background: "var(--t4)" }}></span>{" "}
                  Billing
                </div>
              </div>
            </div>
            {/* <div class="ol-actions">
              <button type="button" class="ol-btn primary" id="rcDownload">
                <i class="bi bi-download"></i> Download
              </button>
            </div> */}
          </div>

          {/* <!-- ═══════════ INTRO ═══════════ --> */}
          <div class="ig-hero">
            <span class="ig-eyebrow">
              <i class="bi bi-receipt"></i> Pricing &amp; Charges
            </span>
            <h1 class="ig-title">Rate Card</h1>
            <p class="ig-desc">
              Domestic shipping rates offered by our courier partners across all
              zones.
              {/* with RTO and COD charges */}
              Amounts are per shipment before taxes.
            </p>
          </div>

          <div class="rc-wrap">
            {/* <!-- ═══════════ SHIPPING RATE CARDS ═══════════ --> */}

            <div class="rc-grid" id="rcGrid">
              {/* <?php foreach ($RC_CARDS as $card): ?> */}
              {products.length > 0
                ? products.map((product, productIndex) => (
                    <div
                      class="card-base rc-card"
                      data-courier="<?php echo htmlspecialchars($card['courier']); ?>"
                      data-name="<?php echo htmlspecialchars(strtolower($card['name'])); ?>"
                    >
                      <div class="rc-card-head">
                        <div
                          class="rc-card-avatar"
                          style={{
                            width: "40px",
                            height: "40px",
                            borderRadius: "50%",
                            background: "#1976d2", // choose your color
                            color: "#fff",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontWeight: "bold",
                            fontSize: "16px",
                            marginRight: "12px",
                            flexShrink: 0,
                          }}
                        >
                          {getProductInitials(product.product_name)}
                        </div>
                        <div class="rc-card-tx">
                          <h3 class="rc-card-title">
                            {" "}
                            {product.product_name}{" "}
                          </h3>
                          <span class="rc-card-tag">
                            <i class="bi bi-geo-alt"></i> {product.mode}
                          </span>
                        </div>
                      </div>
                      <div class="rc-table-wrap">
                        <table class="rc-table">
                          <thead>
                            <tr>
                              {/* <?php foreach ($ZONES as $z): ?> */}
                              <th>Weight Range (KG)</th>
                              {product.zones.map((zone, idx) => (
                                <th>{zone.zone_name}</th>
                              ))}
                              {/* <?php endforeach; ?> */}
                            </tr>
                          </thead>
                          <tbody>
                            {/* <?php foreach ($card['rows'] as $row): ?> */}
                            {product.groupedPricing.map((range, idx) => (
                              <tr
                                key={idx}
                                className={
                                  idx % 2 === 0 ? "bg-white" : "bg-gray-50"
                                }
                              >
                                <td className="p-3 border border-gray-300 font-medium text-gray-700">
                                  {range.start_range} - {range.end_range}
                                </td>
                                {product.zones.map((zone, zIdx) => {
                                  const zonePrice = range.zone_prices.find(
                                    (zp) => zp.zone_id === zone.zone_id
                                  );
                                  return (
                                    <td
                                      key={zIdx}
                                      className="p-3 border border-gray-300 text-center"
                                    >
                                      {zonePrice ? zonePrice.price : "N/A"}
                                    </td>
                                  );
                                })}
                              </tr>
                            ))}
                            <tr>
                              <td>
                                Additional per {product.additional_weight} KG
                              </td>
                              {product.zones.map((zone, zIdx) => {
                                const additionalPrice =
                                  product.additionalPrices.find(
                                    (ap) => ap.zone_id === zone.zone_id
                                  )?.additional_price || "N/A";
                                return (
                                  <td
                                    key={zIdx}
                                    className="p-3 border border-gray-300 text-center"
                                  >
                                    {additionalPrice}
                                  </td>
                                );
                              })}
                            </tr>
                            {/* <?php endforeach; ?> */}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  ))
                : // <p className="text-gray-500 text-center py-4">
                  //   No products available to display.
                  // </p>
                  ""}
              {/* <?php endforeach; ?> */}
            </div>

            {/* <!-- ═══════════ RTO PRICING ═══════════ --> */}
            {/* <div class="card-base rc-extra" id="rcRto">
              <div class="rc-extra-head">
                <span class="rc-extra-ic rc-extra-ic-rto">
                  <i class="bi bi-arrow-return-left"></i>
                </span>
                <div>
                  <h3 class="rc-extra-title">RTO Pricing</h3>
                  <p class="rc-extra-sub">
                    Return-to-origin charges levied when a shipment can&rsquo;t
                    be delivered and is returned.
                  </p>
                </div>
              </div>
              <div class="rc-table-wrap">
                <table class="rc-table">
                  <thead>
                    <tr>
                      <th>Courier</th>
                      <th>RTO Charge</th>
                      <th>Minimum RTO Fee</th>
                      <th>Return Pickup Fee</th>
                      <th>Notes</th>
                    </tr>
                  </thead>
                  <tbody>
                  
                    <tr>
                      <td>
                        <span class="rc-courier">
                          <span
                            class="rc-badge rc-badge-sm"
                           >
                          
                          </span>
                         
                        </span>
                      </td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td class="rc-note"></td>
                    </tr>
                   
                  </tbody>
                </table>
              </div>
            </div> */}

            {/* <!-- ═══════════ COD CHARGES ═══════════ --> */}
            {/* <div class="card-base rc-extra" id="rcCod">
              <div class="rc-extra-head">
                <span class="rc-extra-ic rc-extra-ic-cod">
                  <i class="bi bi-cash-coin"></i>
                </span>
                <div>
                  <h3 class="rc-extra-title">COD Charges</h3>
                  <p class="rc-extra-sub">
                    Handling fees charged per Cash-on-Delivery order, plus
                    limits and remittance cycle.
                  </p>
                </div>
              </div>
              <div class="rc-table-wrap">
                <table class="rc-table">
                  <thead>
                    <tr>
                      <th>Courier</th>
                      <th>COD Charge</th>
                      <th>Minimum Price</th>
                    </tr>
                  </thead>
                  <tbody>
                   
                    <tr>
                      <td>
                        <span class="rc-courier">
                          <span
                            class="rc-badge rc-badge-sm"
                           
                          >
                           
                          </span>
                         
                        </span>
                      </td>
                      <td></td>
                      <td></td>
                    </tr>
                  
                  </tbody>
                </table>
              </div>
            </div> */}

            <p class="rc-foot">
              <i class="bi bi-info-circle"></i> Rates are indicative for
              domestic shipments and may change without notice. Final charges
              are confirmed at the time of shipment booking.
            </p>
          </div>
        </div>
      </Header>
      <Footer />
    </div>
  );
};

export default Rate_card;
